import type { UsePaywallCheckoutReturn } from "@circle-react/contexts/Paywalls/usePaywallCheckout";

import { PaywallCustomization } from "../../PaywallCustomization";
import { CouponTag } from "./CouponTag";
import { PriceDisplay } from "./PriceDisplay";
import { PriceSubtitle } from "./PriceSubtitle";
import type { PriceScenariosProps } from "./types";

interface PriceDescriptionProps extends PriceScenariosProps {
  couponPreviewMutation: UsePaywallCheckoutReturn["couponPreviewMutation"];
}

export const PriceDescription = (props: PriceDescriptionProps) => {
  const { price, couponPreviewMutation } = props;

  return (
    <div className="flex flex-row justify-between">
      <div className="flex flex-col gap-y-1">
        <PaywallCustomization.ReducedPrice
          price={price}
          couponPreviewMutation={couponPreviewMutation}
        >
          <PriceDisplay {...props} />
        </PaywallCustomization.ReducedPrice>
        <PaywallCustomization.PriceCallout price={price}>
          <PaywallCustomization.ReducedPrice
            price={price}
            couponPreviewMutation={couponPreviewMutation}
          >
            <PriceSubtitle {...props} />
          </PaywallCustomization.ReducedPrice>
        </PaywallCustomization.PriceCallout>
      </div>
      <CouponTag
        paywallPriceId={price.id}
        couponPreviewMutation={couponPreviewMutation}
      />
    </div>
  );
};
